// extracted by mini-css-extract-plugin
module.exports = {"Footer":"UpdatePasswordForm_Footer__Cd6XZ","Status":"UpdatePasswordForm_Status__34Q8m"};